import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentComponent } from './equipment.component';
import { EquipmentRoutingModule } from './equipment-routing.module';
import { EquipmentService } from './equipment.service';
import { EquipmentDetailsComponent } from './equipment-details/equipment-details.component';
import { TranslateSharedLazyModule } from '../app-shared/modules/translate-shared-lazy.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TabsModule } from '../app-shared/components/tabs/tabs.module';
import { DynamicBreadCrumbsModule } from '../app-shared/components/bread-crumbs/bread-crumbs.module';
import { DxAccordionModule } from 'devextreme-angular';
import { EquipmentEmptyComponent } from './equipment-empty/equipment-empty.component';
import { LazyLoadingModulesModule } from '../app-shared/directives/lazy-loading-modules.module';
import {LoaderModule} from "../app-shared/components/loader/loader.module";



@NgModule({
  declarations: [
    EquipmentComponent,
    EquipmentDetailsComponent,
    EquipmentEmptyComponent
  ],
    imports: [
        CommonModule,
        EquipmentRoutingModule,
        TranslateSharedLazyModule,
        MatProgressBarModule,
        TabsModule,
        DynamicBreadCrumbsModule,
        DxAccordionModule,
        LazyLoadingModulesModule,
        LoaderModule
    ],
  exports: [
    EquipmentComponent
  ],
  providers: [EquipmentService],
})
export class EquipmentModule { }
